<template>
  <slot v-bind="{ visible, tags }"  />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useProductsStore } from '@/stores'
const store = useProductsStore()

const props = defineProps<{
  tags: string[]
  bundleProductId: number
  productHandle: string
  productId: number
}>()

const visible = computed(() => {
  const { tags } = props
  const filter = store.filter
  if (filter === 'all') {
    return true
  } else if (filter.startsWith('no-')) {
    const tag = filter.replace('no-', '')
    return !tags.includes(tag)
  } else {
    return tags.includes(filter)
  }
})
</script>
